
import React, { useState } from 'react';
import { history } from 'state/store';
import styled from 'styled-components';
import { media } from 'utils/style';
import { useTranslation } from 'react-i18next';
import routes from 'utils/routes';

const LandingContentContainer = styled.div`
  display: block;
  width: 348px;
  height: 360px;
  position:absolute;
  top:50%;
  left:50%;
  margin-left:-174px;
  margin-top:-120px;
   ${media.lessThan('extraSmall')`
      width: 300px;
      margin-left:-150px;
  `};
`;

const LandingContentTitle = styled.label`
  display: block;
  color: var(--grey800);
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Roboto;
  font-size: 24px;
  font-weight: 500;
  cursor: text;
  margin-bottom: 12px;
`;

const LandingPrimaryButton = styled.button`
    display: block;
    width: 100%;
    height: 70px;
    text-decoration: none;
    text-align: center;
    margin-bottom: 8px;
    border: 0;
    border-left: 8px solid #CC0000;
    border-radius: 4px;
    cursor: pointer;
    &:hover {
      background-color: ${props => (props.isActive ? 'var(--grey800)' : 'var(--grey300)')};
    }
    background-color: ${props => (props.isActive ? 'var(--grey900)' : 'var(--grey200)')};
    color: ${props => (props.isActive ? 'var(--white)' : 'var(--grey700)')};
`;

const LandingSecundaryButton = styled.button`
  display: ${props => (props.isVisible ? 'block' : 'none')};
  width: 100%;
  height: 50px;
  color: var(--grey700);
  text-decoration: none;
  text-align: center;
  background-color: var(--grey200);
  margin-bottom: 8px;
  border: 0;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: var(--grey300);
  }
  &:active {
    background-color: var(--grey900);
    color: var(--white);
  }
`;

export const LandingMain = () => {
    const { t } = useTranslation('Landing');
    
    const [isActive, setIsActive] = useState(false);
  
    const handleParentButtonClick = () => {
      setIsActive(!isActive);
    };
  
    return (
      <LandingContentContainer>
          <LandingContentTitle>{t('main.title')}</LandingContentTitle>
          <LandingPrimaryButton isActive={isActive} onClick={handleParentButtonClick}>
          {t('main.user')}
          </LandingPrimaryButton>
          <LandingSecundaryButton isVisible={isActive} onClick={() => {
              history.push(routes.loginAccess);
            }}>
            {t('main.access')}
          </LandingSecundaryButton>
          <LandingSecundaryButton isVisible={isActive} onClick={() => {
              history.push(routes.signup);
            }}>
          {t('main.register')}
          </LandingSecundaryButton>
          <LandingPrimaryButton onClick={() => {
              window.open(t('main.not_user_link'), '_blank');
            }}>
            {t('main.not_user')}
          </LandingPrimaryButton>
      </LandingContentContainer>
    );
  };
  